
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import Input from '@/components/Core/Input.vue';

  import { ISendConfirmEmailModel } from '@/models/account.model';
  import { IErrorModel } from '@/models/errors.model';

  import accountService from '@/services/account.service';

  @Component({
    components: {
      Input
    },
    computed: {
      ...mapGetters([
        'isLoading'
      ])
    }
  })
  export default class ConfirmEmailSend extends Vue {
    data() {
      return {
        studio: '',
        hasErrors: false,
        isSendLoading: false,
        errors: new Array<IErrorModel>(),
        email: ''
      }
    };

    created() {
      this.$data.studio = this.$data.RCEnvironment.VUE_APP_PARTNER_NAME;
    }

    sendEmailConfirmation() {
      if (this.$data.isSendLoading) {
        return;
      }

      this.$store.dispatch("updateIsLoading", true);
      this.$data.isSendLoading = true;

      setTimeout(() => {
        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "email/send-confirmation-email";

        accountService.post<ISendConfirmEmailModel, object>(this, url, { Email: this.$data.email })
          .then(() => {
            this.$store.dispatch("updateIsLoading", false);
            this.$data.isSendLoading = false;
            this.$router.push({ name: 'ConfirmRegister' });
          })
          .catch(error => {
            this.$store.dispatch("updateIsLoading", false);
            this.$data.isSendLoading = false;
            this.$data.hasErrors = true;
            this.$data.errors = error.data.ErrorMessages;
          });
      }, 300);
    }

    updateEmailValue(parameter: string, value: string) {
      this.$set(this.$data, "email", value);
    }
  }

